var Vec2 = (function () {
    function Vec2(vec) {
        if (vec) {
            this.copy(vec);
        }
        else {
            this.x_ = 0;
            this.y_ = 0;
        }
    }
    Object.defineProperty(Vec2.prototype, "x", {
        get: function () {
            return this.x_;
        },
        set: function (value) {
            this.x_ = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec2.prototype, "y", {
        get: function () {
            return this.y_;
        },
        set: function (value) {
            this.y_ = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ;
    Object.defineProperty(Vec2.prototype, "vec2_t", {
        get: function () {
            return { x: this.x, y: this.y };
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec2.prototype, "magnitude", {
        get: function () {
            return Math.sqrt(this.squared_length);
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Vec2.prototype, "squared_length", {
        get: function () {
            return Math.pow(this.x, 2) + Math.pow(this.y, 2);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Vec2.fromArray = function (array) {
        return new Vec2({
            x: array[0] || 0,
            y: array[1] || 0
        });
    };
    ;
    Vec2.magnitude = function (a) {
        return Math.sqrt(Math.pow(a.x, 2) + Math.pow(a.y, 2));
    };
    ;
    Vec2.squaredLength = function (a) {
        return Math.pow(a.x, 2) + Math.pow(a.y, 2);
    };
    ;
    Vec2.dot = function (a, b) {
        return a.x * b.x + a.y * b.y;
    };
    ;
    Vec2.cross = function (a, b) {
        return (a.x * b.y) - (a.y * b.x);
    };
    ;
    Vec2.scalarCross = function (a, s) {
        return { x: a.y * -s, y: a.x * s };
    };
    ;
    Vec2.normalise = function (a, out) {
        var length = Vec2.magnitude(a);
        if (length > 0) {
            var factor = 1.0 / length;
            return Vec2.scale(a, factor, out);
        }
        else {
            if (out) {
                out.setZero();
            }
            return { x: 0, y: 0 };
        }
    };
    ;
    Vec2.add = function (a, b, out) {
        var sum = {
            x: a.x + b.x,
            y: a.y + b.y
        };
        if (out) {
            out.copy(sum);
        }
        return sum;
    };
    ;
    Vec2.subtract = function (a, b, out) {
        var diff = {
            x: a.x - b.x,
            y: a.y - b.y
        };
        if (out) {
            out.copy(diff);
        }
        return diff;
    };
    ;
    Vec2.scale = function (a, scalar, out) {
        var scaled = {
            x: a.x * scalar,
            y: a.y * scalar
        };
        if (out) {
            out.copy(scaled);
        }
        return scaled;
    };
    ;
    Vec2.inverse = function (a, out) {
        var inverse = {
            x: -a.x + 0,
            y: -a.y + 0
        };
        if (out) {
            out.copy(inverse);
        }
        return inverse;
    };
    ;
    Vec2.perLeft = function (a, out) {
        var left = {
            x: -a.y + 0,
            y: a.x
        };
        if (out) {
            out.copy(left);
        }
        return left;
    };
    ;
    Vec2.perRight = function (a, out) {
        var right = {
            x: a.y,
            y: -a.x + 0
        };
        if (out) {
            out.copy(right);
        }
        return right;
    };
    ;
    Vec2.stringify = function (a) {
        return "x: " + a.x + ", y: " + a.y;
    };
    ;
    Vec2.isZero = function (a) {
        return a.x === 0 && a.y === 0;
    };
    ;
    Vec2.areEqual = function (a, b) {
        return a.x === b.x && a.y === b.y;
    };
    ;
    Vec2.min = function (a, b) {
        var min = function (a, b) { return a < b ? a : b; };
        return { x: min(a.x, b.x), y: min(a.y, b.y) };
    };
    ;
    Vec2.max = function (a, b) {
        var max = function (a, b) { return a > b ? a : b; };
        return { x: max(a.x, b.x), y: max(a.y, b.y) };
    };
    ;
    Vec2.prototype.setZero = function () {
        this.x_ = 0;
        this.y_ = 0;
    };
    ;
    Vec2.prototype.copy = function (v) {
        this.x_ = v.x;
        this.y_ = v.y;
    };
    ;
    Vec2.ZERO = { x: 0, y: 0 };
    Vec2.LEFT = { x: -1, y: 0 };
    Vec2.UP = { x: 0, y: 1 };
    Vec2.RIGHT = { x: 1, y: 0 };
    Vec2.DOWN = { x: 0, y: -1 };
    return Vec2;
}());
export { Vec2 };
;
//# sourceMappingURL=vec2.js.map